@for (piece of parts().name; track $index) {
  <span class="truncate" [class.font-mono]="piece.mono">{{ piece.text }}</span>
}
@for (piece of parts().detail; track $index) {
  <span class="shrink-0 whitespace-nowrap opacity-80">· {{ piece.text }}</span>
}
